import { ICard } from './Card';

export enum IdentityType {
  EMAIL = 'email',
  MOBILE = 'mobile',
}

export enum ChannelType {
  CALL = 'call',
}

export interface ICreateIdentity {
  identity: string;
}

export interface IVerifyIdentityRequest {
  verifyCode: string;
}

export interface IResetIdentityRequest {
  dateOfBirth: string;
}

export interface IIdentity {
  id: string;
  type: IdentityType;
  value: string;
  verified: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

export interface IVerifyIdentity {
  id: string;
  firstName: string;
  lastName: string;
  identities: IIdentity[];
  termsOfService: ITermsOfService[];
  privacyPolicy: IPrivacyPolicy[];
  createdAt: string;
  updatedAt: string;
  dateOfBirth?: string;
  googleId?: string;
  hasPin?: string;
  jwt?: string;
}

export interface IResetIdentity extends IVerifyIdentity {
  email: string;
  mobile: string;
  avatarUrl: string;
  verified: boolean;
  card: ICard;
  deletedAt: string;
}

export interface ITermsOfService {
  version: string;
}
export interface IPrivacyPolicy extends ITermsOfService {}
